import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
  CSSProperties,
  useCallback,
} from "react";
import instance from "../../util/axios";
import { Toast } from "antd-mobile-v5";
import moment from "moment";
import Grid from "../Grid";
import styled from "styled-components";
import { groupBy } from "../../util/groupBy";

interface TableGridProps {
  id?: string;
  entityName: string;
  columnCount?: number;
  mvp?: boolean;
  hiddenFields?: string[];
  editFields?: string[];
  defaultValues?: { [key: string]: any };
  silent?: boolean;
  group?: boolean;
  editable?: boolean;
  multipeable?: boolean;
  category?: string;
  editType?: string;
  onError?: () => void;
  onSaved?: (uuid: string, status?: string) => void;
  style?: CSSProperties;
  onChange?: (root: any, setValue: (field: string, value: any) => void) => void;
  className?: string;
}

const TableGridWrapper = styled.div`
  background: #f7f7f7;
  .classifyName {
    margin-top: 10px;
    background: #ffffff;
  }
  .am-input-item,
  .am-textarea-item {
    flex: 1;
  }
  .am-list-item .am-list-line .am-list-content {
    font-size: 15px;
  }
  .am-textarea-item {
    padding-right: 15px;
  }
  .am-textarea-item textarea {
    text-align: left;
  }
  .text-align-left {
    text-align: left;
  }
  .classifyName {
    font-size: 16px;
    padding: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.34);
  }
  .adm-form-item-label-required {
    color: var(--adm-color-danger);
  }
  .border-bottom-d9 {
    border-bottom: 1px solid #f3f1f1;
  }
  .table-grid-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
    width: 100px;
    margin-left: 15px;
    padding-top: 15px;
    display: flex;
  }
  .table-grid-item-date-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
    width: 100px;
  }
  .am-swipe {
    background: #fff;
    padding-right: 15px;
  }
  .am-list-item: not(: last-child) .am-list-line {
    border-bottom: none;
  }
  .arrow-right-button {
    position: absolute;
    right: 15px;
    top: 17px;
    color: rgba(0, 0, 0, 0.34);
    cursor: pointer;
  }
`;
export const TableGrid = forwardRef(
  (
    {
      id = "0",
      entityName,
      columnCount = 1,
      mvp = true,
      hiddenFields,
      editFields,
      group = false,
      defaultValues,
      category,
      editType,
      editable = true,
      multipeable = false,
      silent = false,
      onSaved,
      onError,
      style,
      onChange,
      className,
    }: TableGridProps,
    ref: any
  ) => {
    const [data, setData] = useState<any>();
    const [innerData, setInnerData] = useState<any>();
    const [descriptions, setDescriptions] = useState<any[]>([]);
    const formRef = useRef<any>(null);
    useImperativeHandle(ref, () => ({
      save: function () {
        return save();
      },
      refresh: function () {
        loadData();
      },
      getData: function () {
        return formRef.current.getData();
      },
    }));

    const loadData = useCallback(async () => {
      const resp = await instance.get(
        `/crm/field/description/grid/byTableName/?tableName=${entityName}`
      );
      if (resp.data.Status === "1") {
        const dataResp = await instance.get(
          `/crm/dynamicentity/data/byTableName/?tableName=${entityName}&id=${id}`
        );
        let descriptions = resp.data.Data.map((item: { readOnly: any }) =>
          Object.assign(item, { readonly: item.readOnly })
        ).filter(
          (item: { fieldName: any }) =>
            !hiddenFields?.some((ele) => ele === item.fieldName)
        );
        descriptions = descriptions.filter(
          (item: { classify: string }) => item.classify && item.classify != ""
        );
        // if (group) {
        //   const groupArray = groupBy(
        //     descriptions,
        //     function (item: { classify: string }) {
        //       return [item.classify];
        //     }
        //   );
        //   debugger;
        //   groupArray.forEach((element) => {
        //     if (element.length > 0) {
        //       element.unshift({
        //         fieldShowName: element[0].classify,
        //         inputType: 22,
        //         Name: "tablegridGroupName",
        //       });
        //     }
        //   });
        //   descriptions = groupArray.reduce((a, b) => a.concat(b));
        // }
        setDescriptions(descriptions);
        if (dataResp.data.Status === "1") {
          let data = dataResp.data.Data || {};
          data = Object.assign(data, defaultValues);
          setData(data);
          setInnerData(data);
        }
      }
    }, [defaultValues, entityName, hiddenFields, id]);

    useEffect(() => {
      loadData();
    }, []);

    const save = useCallback(async () => {
      const validate = formRef.current?.validate();
      if (!validate.flag) {
        Toast.show({
          content: `请填写${validate.errorFieldShowNames[0]}`,
        });
        return;
      }
      const newData = Object.assign(data, defaultValues);
      let resp = await instance.post(`/crm/dynamicentity/data/byTableName/`, {
        tableName: entityName,
        json: JSON.stringify(newData),
      });
      if (resp.data.Status == "1") {
        Toast.show({
          content: "保存成功",
        });
        onSaved?.(resp.data.Data);
      } else {
        Toast.show({
          content: resp.data.Message,
        });
      }
    }, [data, defaultValues, entityName, onSaved]);

    const onChangeGrid: any = useCallback((currentData: any, onChange: any) => {
      if (currentData && JSON.stringify(currentData) !== "{}") {
        setData(currentData);
      }
    }, []);

    return (
      <>
        {descriptions.length > 0 && innerData && (
          <TableGridWrapper id="tablegrid-wrapper" className={className}>
            <Grid
              ref={formRef}
              swipeActionable={false}
              descriptions={descriptions}
              data={innerData}
              onChange={onChangeGrid}
              groupable={group}
              // key={new Date().toString()}
            />
          </TableGridWrapper>
        )}
      </>
    );
  }
);
